import React, { memo } from 'react';
import './login.css';
import { LoginForm } from '../../components';

const LoginScreen = memo(() => {
  return <LoginForm />;
});

LoginScreen.displayName = 'LoginScreen';

export { LoginScreen };
